// extracted by mini-css-extract-plugin
module.exports = {"container":"UtilizationRateGraph_container__Hufec","graph":"UtilizationRateGraph_graph__MAQxn"};